import React from 'react'

import { InputUI, PriceString } from '@fourthwall/components'
import type { Money } from '@fourthwall/services/dist/models/common'

import * as S from './CurrentMonthSpending.styled'

export type CurrentMonthSpendingProps = {
  value: Money
}

export const CurrentMonthSpending = ({ value }: CurrentMonthSpendingProps) => (
  <S.Container>
    <InputUI.Label $size="large" $hasValue>
      Charged this month
    </InputUI.Label>
    <S.Content>
      <PriceString {...value} />
    </S.Content>
  </S.Container>
)
